module.exports = __webpack_public_path__ + "assets/img/23.dd1091c7.jpg";